import type {
	CombinedItem,
	AdvertisementItem
} from "~/types/components/category";
import type { AdvertisementBlok } from "~/types/storyblok/storyblok";

/**
 * Merges product items with advertisements based on configuration
 * @param productItems - Array of product items to merge
 * @param adsConfig - Advertisement configuration (optional)
 * @returns Combined array of products and advertisements
 */
export function mergeWithAdvertisements(
	productItems: CombinedItem[],
	adsConfig?: AdvertisementBlok | null
): CombinedItem[] {
	if (!adsConfig) {
		return productItems;
	}

	const result = [...productItems];
	const positions = adsConfig.items_position?.split(",").map(Number) || [];
	const fullWidthItems = adsConfig?.items_width
		? adsConfig.items_width.split(",")
		: [];

	adsConfig.items.forEach((adItem, index) => {
		const position = positions[index] ? positions[index] - 1 : -1;
		const ad: AdvertisementItem = {
			type: "advertisement" as const,
			id: adItem._uid,
			data: adItem,
			isFullWidth: fullWidthItems.includes(`${index}`)
		};

		if (position >= 0 && position <= result.length) {
			result.splice(position, 0, ad);
		} else {
			result.push(ad);
		}
	});

	return result;
}
